"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForMs = void 0;
// pause execution for a given number of milliseconds
async function waitForMs(ms) {
    await new Promise((resolve) => setTimeout(resolve, ms));
}
exports.waitForMs = waitForMs;
//# sourceMappingURL=util.js.map